
export const QUERY_BUILDER_PROFILEGROUPS_GET = "/queryBuilder/v1/ProfileFilter/GetProfileGroupDefs"
export const QUERY_BUILDER_PROFILES_GET = "/queryBuilder/v1/ProfileFilter/GetProfileDefsByGroupGuid"
export const QUERY_BUILDER_PROFILEFILTERS_GET = "/queryBuilder/v1/ProfileFilter/GetProfileFilterFieldsByGroupGuid"
